import { InputBase, Select as MuiSelect, SelectProps as MuiSelectProps, styled } from '@mui/material';

const StyledSelect = styled(MuiSelect)({
    height: '100%',
    width: '100%',
});

const InputSelect = styled(InputBase)({
    height: '100%',
    width: '100%',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'stretch',

    '.MuiInputBase-input:focus': {
        background: 'transparent',
    },

    '.MuiSelect-select': {
        height: '100%',
        minHeight: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        cursor: 'pointer',
        display: 'flex',
        flexGrow: 1,
        gap: '15px',
        alignItems: 'center',
        overflow: 'hidden',
        padding: '0 24px 0 0',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});

export type SelectBaseV2Props = MuiSelectProps & {}

export default function SelectBaseV2(props: SelectBaseV2Props) {
    return <StyledSelect 
        variant="standard"
        input={<InputSelect/>}
        {...props} 
    />
}
